import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { routes } from './utils/constants/config';
import { getDefaultLandingRoute } from './view/system/systemAction';
import Project from './view/project/Project';
import Studies from './view/studies/Studies';
import WorklistPage from './view/studies/WorklistPage';
import StudyList from './view/studyList/StudyList';
import LabelManagement from './view/labelManagement/LabelManagement';
import AdminDashboard from './view/adminDashboard/AdminDashboard';
import TeleradiologyPage from './view/teleradiology/TeleradiologyPage';
import TeleradiologyAnalytics from './view/teleradiology/TeleradiologyAnalytics';
import TeleradiologyTeam from './view/teleradiology/TeleradiologyTeam';

// Role-aware landing route. POs → Admin Dashboard, radiologists →
// My Worklist, everyone else → My Projects. Shared with getAccountInfo
// so the fresh-login full-page redirect and the in-app `/` redirect
// always agree.
const DefaultLandingRedirect = connect((state) => ({
  userInfo: state.system.profile,
}))(({ userInfo }) => {
  // While the profile is still loading, render nothing — the redirect
  // would otherwise lock in before role data arrives.
  if (!userInfo) return null;
  return <Redirect to={getDefaultLandingRoute(userInfo)} />;
});

const Routes = (props) => {
  return (
    <Switch>
      <Route exact path="/" component={DefaultLandingRedirect} />
      <Route exact path={routes.PROJECTS} component={Project} />
      <Route exact path={routes.STUDIES} component={Studies} />
      <Route exact path={routes.WORKLIST} component={WorklistPage} />
      <Route exact path={routes.STUDY_LIST_ID} component={StudyList} />
      <Route exact path={routes.LABEL_MANAGEMENT} component={LabelManagement} />
      <Route exact path={routes.ADMIN_DASHBOARD} component={AdminDashboard} />
      <Route exact path={routes.TELERADIOLOGY} component={TeleradiologyPage} />
      <Route exact path={routes.TELERADIOLOGY_ANALYTICS} component={TeleradiologyAnalytics} />
      <Route exact path={routes.TELERADIOLOGY_TEAM} component={TeleradiologyTeam} />
    </Switch>
  );
};

export default Routes;
